import React from 'react'
import styles from './Central.module.css'
import MainMenuToggle from './MainMenuToggle'
import SearchToggle from './SearchToggle'
import UserMenuToggle from './UserMenuToggle'
import LanguageSelector from './LanguageSelector'
import MainMenu from '../../MainMenu'
import SearchPanel from '../../SearchPanel'
import PropTypes from 'prop-types'
import MainCategories from './MainCategories'
import ClientOnly from '../../../../../legacy_components/ClientOnly'
import I24NewsPlusLink from './I24NewsPlusLink'
import LiveRadioLink from './LiveRadioLink'
import { getLocales, isHebrew, isPersian } from '../../../../../utilities/locales'

const Central = ({
  onMainMenuOpen,
  onMainMenuClose,
  isMainMenuOpened,
  onSearchPanelOpen,
  onSearchPanelClose,
  isSearchPanelOpened,
  onUserMenuOpen,
  onUserMenuClose,
  isUserMenuOpened,
  locale,
}) =>
  <ul className={ styles.list }>
    <li>
      <MainMenuToggle isActive={ isMainMenuOpened } onClick={ isMainMenuOpened ? onMainMenuClose : onMainMenuOpen } />
      <MainMenu isOpen={ isMainMenuOpened } />
    </li>
    <li>
      <SearchToggle isActive={ isSearchPanelOpened } onClick={ isSearchPanelOpened ? onSearchPanelClose : onSearchPanelOpen } />
      <SearchPanel isOpen={ isSearchPanelOpened } />
    </li>
    <li className={ styles.central }>
      <ClientOnly><MainCategories /></ClientOnly>
    </li>
    { !isHebrew(locale) && !isPersian(locale) ? <li className={ styles['i24News-plus-item'] }><I24NewsPlusLink /></li> : null }
    <li>
      <UserMenuToggle isActive={ isUserMenuOpened } onClick={ isUserMenuOpened ? onUserMenuClose : onUserMenuOpen } />
    </li>
    <li className={ `${styles['locale-menu-item']} ${isHebrew(locale) ? styles.he : ''}` }>
      <LanguageSelector />
    </li>
    { isHebrew(locale) || isPersian(locale) ? <li className={ styles['live-radio-item'] }><LiveRadioLink /></li> : null }
  </ul>

Central.propTypes = {
  onMainMenuOpen: PropTypes.func.isRequired,
  onMainMenuClose: PropTypes.func.isRequired,
  isMainMenuOpened: PropTypes.bool.isRequired,
  onSearchPanelOpen: PropTypes.func.isRequired,
  onSearchPanelClose: PropTypes.func.isRequired,
  isSearchPanelOpened: PropTypes.bool.isRequired,
  onUserMenuOpen: PropTypes.func.isRequired,
  onUserMenuClose: PropTypes.func.isRequired,
  isUserMenuOpened: PropTypes.bool.isRequired,
  locale: PropTypes.oneOf(getLocales()).isRequired,
}

export default Central
